import script from "./DeleteEncounterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteEncounterModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteEncounterModal.vue?vue&type=style&index=0&id=68af5759&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68af5759"]])

export default __exports__